import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Box,
  Button,
  TextField,
} from '@mui/material';

import SuperAdminContext from "../../../contexts/SuperAdminContext"

import TopBar from "../../../components/ui/Admin/TopBar"
import FormationCard from "../../../components/ui/Admin/Formations/FormationCard"


const filtersTypes = [
  {value : "icebreaker", label : "Icebreaker"},
  {value : "enrich", label : "Enrichir"},
  {value : "identif", label : "Identifier"}
]

const filtersThemes = [
  {value : "efficacite", label : "Efficacité opérationnelle"},
  {value : "communication", label : "Communication et innovation"},
  {value : "leadership", label : "Leadership et collaboration"},
  {value : "demo", label : "Demo"},
]

const filtersNiveaux = [
  {value : "1", label : "1"},
  {value : "2", label : "2"},
  {value : "3", label : "3"}
]

const filtersCibles = [
  {value : "school", label : "École"},
  {value : "corpo", label : "Corporate"},
]

const filtersLangues = [
  {value : "fr", label : "Français"},
  {value : "en", label : "Anglais"},
]

const Formations = () => {
  const navigate = useNavigate()

  const { contents, updateAdminContents } = useContext(SuperAdminContext)

  const [formationsDisplay, setFormationsDisplay] = useState([])

  /* ⛔ POURQUOI UNE RECHERCHE (09/09/2026). Le catalogue compte 90 modules,
     dont 73 actifs. Les cinq filtres existants portent sur des categories
     (type, theme, niveau, cible, langue) : ils ne servent a rien quand on
     cherche « B1 » ou « FREE FROM CONFLICT » et qu'on connait deja le nom.
     Nawal parcourait donc la liste a l'oeil.
     On cherche dans le nom ET le sous-titre, sans tenir compte des accents ni
     de la casse : « stay focus » doit trouver « STAY FOCUS ON B1 », et
     « evaluation » doit trouver « Évaluation ». */
  const [recherche, setRecherche] = useState("")
  const sansAccent = (v) => (v || "").toString()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()

  const [filters, setFilters] = useState({
    types : [],
    themes : [],
    niveaux: [],
    cibles : [],
    langues : [],
  })

  const resetFilterTypes = () => {
    let elem = document.getElementById("filterTypes")
    if (elem) {
      Array.from(elem?.options).forEach((o) => {
        o.selected = false
      })
    }
    setFilters({
      ...filters,
      types: []
    });
  }

  const resetFilterThemes = () => {
    let elem = document.getElementById("filterThemes")
    if (elem) {
      Array.from(elem?.options).forEach((o) => {
        o.selected = false
      })
    }
    setFilters({
      ...filters,
      themes: []
    });
  }

  const resetFilterNiveaux = () => {
    let elem = document.getElementById("filterNiveaux")
    if (elem) {
      Array.from(elem?.options).forEach((o) => {
        o.selected = false
      })
    }
    setFilters({
      ...filters,
      niveaux: []
    });
  }

  const resetFilterCibles = () => {
    let elem = document.getElementById("filterCibles")
    if (elem) {
      Array.from(elem?.options).forEach((o) => {
        o.selected = false
      })
    }
    setFilters({
      ...filters,
      cibles: []
    });
  }

  const resetFilterLangues = () => {
    let elem = document.getElementById("filterLangues")
    if (elem) {
      Array.from(elem?.options).forEach((o) => {
        o.selected = false
      })
    }
    setFilters({
      ...filters,
      langues: []
    });
  }

  useEffect(() => {
    /* ⚠️ La recherche s'applique DANS LES DEUX CAS. Le raccourci « aucun filtre
       actif, on affiche tout » existait avant elle : l'y laisser tel quel
       aurait rendu la recherche inoperante tant qu'aucune categorie n'etait
       cochee, c'est-a-dire dans le cas le plus courant. */
    const mots = sansAccent(recherche).trim()
    const parLeNom = (liste) => (mots === "" ? liste : liste.filter((el) =>
      sansAccent(el?.name).includes(mots) || sansAccent(el?.surname).includes(mots)))

    if (filters?.types?.length === 0 && filters?.themes?.length === 0 && filters?.niveaux?.length === 0 && filters?.cibles?.length === 0 && filters?.langues?.length === 0) {
      setFormationsDisplay(parLeNom(contents || []))
    } else {
      let finalFormations = [...contents]

      if (filters?.types?.length > 0) {
        finalFormations = finalFormations.filter((el) => {
          return filters?.types.some((d) => d === el.type)
        })
      }

      if (filters?.themes?.length > 0) {
        finalFormations = finalFormations.filter((el) => {
          return filters?.themes.some((d) => d === el.theme)
        })
      }

      if (filters?.niveaux?.length > 0) {
        finalFormations = finalFormations.filter((el) => {
          return filters?.niveaux.some((d) => d === el.niveau)
        })
      }

      if (filters?.cibles?.length > 0) {
        finalFormations = finalFormations.filter((el) => {
          return filters?.cibles.some((d) => d === el.cible)
        })
      }

      if (filters?.langues?.length > 0) {
        finalFormations = finalFormations.filter((el) => {
          return filters?.langues.some((d) => d === el.langue)
        })
      }

      setFormationsDisplay(parLeNom(finalFormations))
    }
  }, [contents, filters, recherche])

  return (
    <>
      <Helmet>
        <title>Admin Modules | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box
          sx={{
            flex:1,
            padding:"20px",
            backgroundColor:"background.grey",
          }}
        >
          <TopBar
            title="Liste des Modules"
          >
            <TextField
              size="small"
              placeholder="Chercher un module"
              value={recherche}
              onChange={(e) => setRecherche(e.target.value)}
              sx={{ minWidth:"240px", backgroundColor:"#FFFFFF" }}
              inputProps={{ "aria-label":"Chercher un module" }}
            />
            <Button
              variant="contained"
              sx={{ minHeight:"35px !important" }}
              onClick={() => { updateAdminContents(true) }}
            >
              Voir les archives
            </Button>
            <Button
              variant="contained"
              sx={{ minHeight:"35px !important" }}
              onClick={() => { navigate('/admin/formation/add') }}
            >
              + Module
            </Button>
          </TopBar>


          <Box sx={{
            padding:"10px 10px 30px 10px",
            display:"flex",
            width:"100%",
            justifyContent:"space-evenly",
            gap:"10px",
            flexWrap:"wrap"
          }}>
            <Box sx={{display:"flex", gap:'5px'}}>
              <Box sx={{display:"flex", flexDirection:"column", alignItems:"center", gap:"5px"}}>
                <Box>Type(s)&nbsp;:</Box>
                <Box sx={{fontSize:"12px"}}>
                  {filters?.types?.length < 2 &&
                    <>({filters?.types?.length} sélectionné)</>
                  }
                  {filters?.types?.length >= 2 &&
                    <>({filters?.types?.length} sélectionnés)</>
                  }
                </Box>
                <button
                  style={{width:"50px", marginTop:"5px"}}
                  onClick={(e) => { resetFilterTypes() }}
                >
                  Vider
                </button>
              </Box>
              <select
                multiple
                onChange={(e) => {
                  let newArr = []
                  Array.from(e.target.options).forEach((o) => {
                    if (o.selected === true) {
                      newArr.push(o.value)
                    }
                  })
                  setFilters({
                    ...filters,
                    types: newArr
                  });
                }}
                name="filterTypes"
                id="filterTypes"
                style={{width:"100px", height:"75px", padding:"1px"}}
              >
                {filtersTypes.map((filter, index) => {
                  return (
                    <option key={filter.value} value={filter.value}>{filter.label}</option>
                  )
                })}
              </select>
            </Box>
            <Box style={{display:"flex", gap:'5px'}}>
              <Box style={{display:"flex", flexDirection:"column", alignItems:"center", gap:"5px"}}>
                <Box>Thème(s)&nbsp;:</Box>
                <Box sx={{fontSize:"12px"}}>
                  {filters?.themes?.length < 2 &&
                    <>({filters?.themes?.length} sélectionné)</>
                  }
                  {filters?.themes?.length >= 2 &&
                    <>({filters?.themes?.length} sélectionnés)</>
                  }
                </Box>
                <button
                  style={{width:"50px"}}
                  onClick={(e) => { resetFilterThemes() }}
                >
                  Vider
                </button>
              </Box>
              <select
                multiple
                onChange={(e) => {
                  let newArr = []
                  Array.from(e.target.options).forEach((o) => {
                    if (o.selected === true) {
                      newArr.push(o.value)
                    }
                  })
                  setFilters({
                    ...filters,
                    themes: newArr
                  });
                }}
                name="filterThemes"
                id="filterThemes"
                style={{width:"200px", height:"75px", padding:"1px"}}
              >
                {filtersThemes.map((filter, index) => {
                  return (
                    <option key={filter.value} value={filter.value}>{filter.label}</option>
                  )
                })}
              </select>
            </Box>
            <Box sx={{display:"flex", gap:'5px'}}>
              <Box sx={{display:"flex", flexDirection:"column", alignItems:"center", gap:"5px"}}>
                <Box>Niveau(x)&nbsp;:</Box>
                <Box sx={{fontSize:"12px"}}>
                  {filters?.niveaux?.length < 2 &&
                    <>({filters?.niveaux?.length} sélectionné)</>
                  }
                  {filters?.niveaux?.length >= 2 &&
                    <>({filters?.niveaux?.length} sélectionnés)</>
                  }
                </Box>
                <button
                  style={{width:"50px", marginTop:"5px"}}
                  onClick={(e) => { resetFilterNiveaux() }}
                >
                  Vider
                </button>
              </Box>
              <select
                multiple
                onChange={(e) => {
                  let newArr = []
                  Array.from(e.target.options).forEach((o) => {
                    if (o.selected === true) {
                      newArr.push(o.value)
                    }
                  })
                  setFilters({
                    ...filters,
                    niveaux: newArr
                  });
                }}
                name="filterNiveaux"
                id="filterNiveaux"
                style={{width:"100px", height:"75px", padding:"1px"}}
              >
              {filtersNiveaux.map((filter, index) => {
                return (
                  <option key={filter.value} value={filter.value}>{filter.label}</option>
                )
              })}
              </select>
            </Box>
            <Box sx={{display:"flex", gap:'5px'}}>
              <Box sx={{display:"flex", flexDirection:"column", alignItems:"center", gap:"5px"}}>
                <Box>Cible(s)&nbsp;:</Box>
                <Box sx={{fontSize:"12px"}}>
                  {filters?.cibles?.length < 2 &&
                    <>({filters?.cibles?.length} sélectionné)</>
                  }
                  {filters?.cibles?.length >= 2 &&
                    <>({filters?.cibles?.length} sélectionnés)</>
                  }
                </Box>
                <button
                  style={{width:"50px", marginTop:"5px"}}
                  onClick={(e) => { resetFilterCibles() }}
                >
                  Vider
                </button>
              </Box>
              <select
                multiple
                onChange={(e) => {
                  let newArr = []
                  Array.from(e.target.options).forEach((o) => {
                    if (o.selected === true) {
                      newArr.push(o.value)
                    }
                  })
                  setFilters({
                    ...filters,
                    cibles: newArr
                  });
                }}
                name="filterCibles"
                id="filterCibles"
                style={{width:"100px", height:"75px", padding:"1px"}}
              >
                {filtersCibles.map((filter, index) => {
                  return (
                    <option key={filter.value} value={filter.value}>{filter.label}</option>
                  )
                })}
              </select>
            </Box>
            <Box sx={{display:"flex", gap:'5px'}}>
              <Box sx={{display:"flex", flexDirection:"column", alignItems:"center", gap:"5px"}}>
                <Box>Langue(s)&nbsp;:</Box>
                <Box sx={{fontSize:"12px"}}>
                  {filters?.langues?.length < 2 &&
                    <>({filters?.langues?.length} sélectionné)</>
                  }
                  {filters?.langues?.length >= 2 &&
                    <>({filters?.langues?.length} sélectionnés)</>
                  }
                </Box>
                <button
                  style={{width:"50px", marginTop:"5px"}}
                  onClick={(e) => { resetFilterLangues() }}
                >
                  Vider
                </button>
              </Box>
              <select
                multiple
                onChange={(e) => {
                  let newArr = []
                  Array.from(e.target.options).forEach((o) => {
                    if (o.selected === true) {
                      newArr.push(o.value)
                    }
                  })
                  setFilters({
                    ...filters,
                    langues: newArr
                  });
                }}
                name="filterLangues"
                id="filterLangues"
                style={{width:"100px", height:"75px", padding:"1px"}}
              >
                {filtersLangues.map((filter, index) => {
                  return (
                    <option key={filter.value} value={filter.value}>{filter.label}</option>
                  )
                })}
              </select>
            </Box>
          </Box>

          {formationsDisplay?.length === 0 ? (
            <Box sx={{textAlign:"center", width:"100%", fontWeight:"bold"}}>
              Pas de correspondance
            </Box>
          ) : (
            <Box sx={{
              display:"flex",
              flexWrap:"wrap",
              justifyContent:"space-between",
              width:"100%",
              padding : "10px",
              flexWrap:"wrap",
              gap:"30px",
            }}>
              {formationsDisplay.map((formation, i) => {
                return (<FormationCard formation={formation} key={i} />)
              })}
            </Box>
          )}



        </Box>
      </Box>
    </>
  )
};

export default Formations;
